var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',{staticClass:"panel-title"},[_vm._v("Thông tin nạp tiền")]),_c('hr'),_c('recharge-info',{attrs:{"showGuide":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }